import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetch } from "../../actions";
import { InputNumberPadrao, LabelPadrao, LoadingContainerPadrao, ModalPadrao } from "../../components/Base";
import TabelaPadrao from "../../components/TabelaPadrao";
import { BtnAdd, BtnGravar, BtnPadrao, BtnSair } from "../../components/Buttons";
import SelectPesq from "../../components/Selects/SelectPesq";
import { InputNumero } from "../../components/InputNumero";
import Mensagens from "../../components/Mensagens";
import roundCustom from "../../Utils/RoundCustom";
import useTotais from "../../components/Hooks/useTotais";
import { useSave } from "../../components/Hooks/Conexao";
import Pagamento from "../Pagamento/Pagamento";
import { formatarPagamentos } from "../../Utils/utils";
import { EditarLoteIcon, useProdutoLote } from "../../Contexts/ProdutoLoteContext";
import { Radio } from "antd";

const INITIAL_STATE = { produto: [], prds: [] };

function VendaDevolucaoAvulsaModal({ visible, onCancel, ...props }) {
  const [dados, setDados] = useState(INITIAL_STATE);
  const [modeloNF, setModeloNF] = useState(null);
  const [pg, setPg] = useState([]);
  const totais = useTotais(dados.prds, pg);
  const [salvar, salvando] = useSave(() => props.fetch().post("venda/devolver", { ...dados, modeloNF, prds: dados.prds.map(x => ({ ...x, valorTotalDev: x.valorTotal, qtdDev: x.qtd })), pagamentos: formatarPagamentos(pg, totais.troco), valorTotal: totais.liquido, troco: totais.troco }), () => {
    setDados(INITIAL_STATE);
    setPg([]);
    onCancel();
    Mensagens.showSucesso("Devolução avulsa efetuada com sucesso!");
  });

  const { handleProdutoLote } = useProdutoLote();

  const parametros = props?.parametros || {};

  useEffect(() => {
    if (visible) {
      setDados(INITIAL_STATE);

      let modelo;
      let tipoEmissaoNota = parametros['TipoEmissaoNotaVenda'];
      if (tipoEmissaoNota == "Danfe")
        modelo = "nfe";

      setModeloNF(modelo);
    }

  }, [visible]);

  const incluir = prdExt => {
    if (!prdExt && !dados.produto?.length)
      return Mensagens.showWarning("Produto não informado!");

    if (!prdExt?.valorUn && !dados.valorUn)
      return Mensagens.showWarning("Valor unitário não informado!");

    if (!prdExt?.qtd && !dados.qtd)
      return Mensagens.showWarning("Quantidade não informada!");

    const prd = prdExt || dados.produto[0];
    const qtd = prdExt?.qtd || dados.qtd;
    const valorUn = prdExt?.valorUn || dados.valorUn;

    handleProdutoLote(prd, lotes => {
      const aux = [...dados.prds];
      const valorTotal = roundCustom(valorUn * qtd, 2);
      if (dados.prds.find(x => x.id === prd.id)) {
        const ref = aux[aux.findIndex(x => x.id === prd.id)];
        ref.qtd = qtd;
        ref.valorUn = valorUn;
        ref.valorTotal = valorTotal;
        ref.isLote = prd.isLote;
        ref.lotes = lotes;
      } else
        aux.push({ id: prd.id, codigo: prd.codigo, nome: prd.nome, qtd, valorUn, valorTotal, desconto: 0, lotes, isLote: prd.isLote });

      setDados({ ...dados, prds: aux, produto: [], valorUn: null, qtd: null });
    }, props.fetch);
  };

  const columns = [
    {
      Header: "Código",
      accessor: "codigo",
      Footer: " "
    },
    {
      Header: "Descrição",
      Cell: props => <span>
        {props.row.original.nome}
        <EditarLoteIcon onClick={() => incluir(props.row.original)} qtd={props.row.original.qtd} lotes={props.row.original.lotes} isLote={props.row.original.isLote} />
      </span>,
    },
    {
      Header: "Valor unitário",
      accessor: "valorUn",
      tipo: "rs",
    },
    {
      Header: "Quantidade",
      accessor: "qtd",
      SomarQtd: true,
      tipo: "dec",
    },
    {
      Header: "Valor total",
      accessor: "valorTotal",
      Somar: true,
      tipo: "rs",
    },
  ];

  return <>
    <ModalPadrao title="Devolução avulsa" visible={visible} onCancel={onCancel} footer={<>
      <BtnPadrao disabled={!dados.prds?.length} onClick={() => {
        if (!dados.clienteId?.length)
          return Mensagens.showWarning("Cliente não informado!");

        setPg([{ recebido: totais.bruto }]);
      }}>Finalizar</BtnPadrao>
      <BtnSair onClick={onCancel} />
    </>} width={window.innerWidth < 1200 ? window.innerWidth : 1200} >

      <div style={{ minHeight: 500 }}>
        <div style={{ display: "flex" }}>
          <div style={{ width: "50%", marginRight: 10 }}>
            <SelectPesq tabIndex={101} placeholder="Pesquisar cliente" maxTagTextLength={60} title="Cliente" modelo="cliente" onChange={v => setDados({ ...dados, clienteId: v })} value={dados.clienteId} noMargin />
          </div>
          <div style={{ width: "50%" }}>
            <SelectPesq tabIndex={102} placeholder="Pesquisar vendedor" maxTagTextLength={60} title="Vendedor" modelo="vendedor" onChange={v => setDados({ ...dados, vendedorId: v })} value={dados.vendedorId} noMargin />
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <div style={{ width: "60%" }}>
            <SelectPesq placeholder="Selecione o produto" tabIndex={103} title="Produto" modelo="produto" onChange={v => setDados({ ...dados, produto: v, valorUn: !!v?.length ? v[0].preco : 0 })} value={dados.produto} />
          </div>
          <div style={{ width: "20%", margin: "0 10px" }}>
            <LabelPadrao>Valor unitário</LabelPadrao>
            <InputNumero tabIndex={104} placeholder="Valor unitário" style={{ width: "100%" }} value={dados.valorUn} onChange={v => setDados({ ...dados, valorUn: v })} showCurrency />
          </div>
          <div style={{ width: "20%", marginRight: 10 }}>
            <LabelPadrao>Quantidade</LabelPadrao>
            <InputNumberPadrao tabIndex={105} placeholder="Quantidade" style={{ width: "100%" }} value={dados.qtd} onChange={v => setDados({ ...dados, qtd: v })} />
          </div>
          <BtnAdd tabIndex={106} nextTab={103} onClick={incluir} />
        </div>

        <TabelaPadrao columns={columns} data={dados.prds} style={{ marginTop: 25 }} onDelete={v => {
          const aux = [...dados.prds];

          aux.splice(aux.findIndex(x => x.id == v.id), 1);
          setDados({ ...dados, prds: aux });
        }} />
      </div>
    </ModalPadrao>

    <ModalPadrao
      visible={pg.length}
      closable={false}
      title="Finalizar devolução avulsa"
      width={window.innerWidth < 1000 ? window.innerWidth : 1000}
      footer={<>
        <BtnGravar disabled={pg.find(x => x.modalidadeId == null || x.modalidadeId <= 0)} data-cy="btn-fin-modal" id="btn-finalizar" onClick={salvar} loading={salvando}>Finalizar</BtnGravar>
        <BtnSair disabled={salvando} onClick={() => setPg([])} />
      </>}>
      <LoadingContainerPadrao loading={salvando}>
        {props.hasCertificadoDigital && <div style={{ textAlign: "center", marginBottom: 25 }}>
          <LabelPadrao noMargin>Forma de emissão</LabelPadrao>
          <Radio.Group value={modeloNF} onChange={v => setModeloNF(v.target.value)}>
            <Radio style={{ margin: 0 }} value="nfe">Danfe</Radio>
          </Radio.Group>
        </div>}

        <Pagamento totais={totais} pg={pg} setPg={setPg} tabIndex={107} clienteId={(dados.clienteId || [])[0]?.id} tipo="devolucao" />
      </LoadingContainerPadrao>
    </ModalPadrao>
  </>;
}

const mapStateToProps = state => ({ online: state.connection.online, hasCertificadoDigital: state.dados.hasCertificadoDigital, parametros: state.dados.parametros });

export default connect(mapStateToProps, { fetch })(VendaDevolucaoAvulsaModal);